import { Injectable } from '@angular/core';

import { AppSessionService } from '../app-session/app-session.service';
import { Menu } from '../../models/menu';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  public isCollapsed: boolean = true;

  private _sidebar: Menu[] = [
    {
      route: "explorer",
      title: "Explorador",
      icon: "fa-solid fa-magnifying-glass"
    },
    {
      route: "favorites",
      title: "Favoritos",
      icon: "fa-solid fa-heart"
    },
    {
      route: "manual",
      title: "Manual de uso",
      icon: "fa-solid fa-book-bookmark"
    }
  ];

  private _adminSidebar: Menu[] = [
    {
      route: "normateca",
      title: "Normateca",
      icon: "fa-solid fa-folder-tree"
    },
    {
      route: "profiles",
      title: "Perfiles",
      icon: "fa-solid fa-key"
    },
    {
      route: "system-users",
      title: "Usuarios",
      icon: "fa-solid fa-users"
    },
    {
      route: "reports",
      title: "Reportes",
      icon: "fa-solid fa-chart-column"
    },
    {
      route: "explorer",
      title: "Explorador",
      icon: "fa-solid fa-magnifying-glass"
    },
    {
      route: "favorites",
      title: "Favoritos",
      icon: "fa-solid fa-heart"
    },
    {
      route: "manual",
      title: "Manual de uso",
      icon: "fa-solid fa-book-bookmark"
    }
  ];

  constructor(
    private readonly _appSessionService: AppSessionService
  ) { }

  public get sidebar(): Menu[] {
    return this._appSessionService.session?.isAdmin ? this._adminSidebar : this._sidebar;
  }

  /**
   * Event to handle open or close sidebar.
   */
  public toggleSidebar(): void {
    this.isCollapsed = !this.isCollapsed;
    this.isCollapsed ? document.body.classList.remove('overflow-hidden') : document.body.classList.add('overflow-hidden');
  }
}